import React from 'react';

import ModalOuterContainer from '../../generic/containers/ModalOuterContainer';
import Button from 'components/shared/generic/button/presentational/Button';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import Field from 'components/shared/form/presentational/Field';
import Select from 'components/shared/form/presentational/Select';
import useTranslate from 'suits-me-npm/languages/useTranslate';
import { formatMoney } from 'suits-me-npm/utils';
import { newCardFees } from 'suits-me-npm/constants/fees';

const StatusCardModal = ({
    handleSubmit,
    handleChange,
    handleClose,
    status,
    productType,
    options,
}) => {
    const translate = useTranslate('cards.orderReplacementModal');

    return (
        <ModalOuterContainer customButtons={true}>
            <div className="description">
                <Typography tag="h1">{translate('titleText')}</Typography>
                <Typography styles={{ marginBottom: '8px' }}>
                    {translate('descriptionText')}
                </Typography>
                <Typography styles={{ marginBottom: '8px' }}>
                    {translate('feeWarning', {
                        fee: formatMoney(newCardFees[productType]),
                    })}
                </Typography>
                <Typography>{translate('blockedWarning')}</Typography>
                <Field>
                    <Select
                        name="status"
                        value={status}
                        options={options}
                        onChange={handleChange}
                        placeholder={translate('placeholder')}
                    />
                </Field>
            </div>
            <div className="button-container">
                <Button className="cancel" onClick={handleClose}>
                    {translate('cancel')}
                </Button>
                <Button onClick={handleSubmit}>
                    {translate('submitText')}
                </Button>
            </div>
        </ModalOuterContainer>
    );
};

export default StatusCardModal;
